import { AdminUserList } from './AdminUserList'
import { AdminUserCreate } from './AdminUserCreate'
import { AdminUserEdit } from './AdminUserEdit'

import { GroupList } from './GroupList'
import { GroupEdit } from './GroupEdit'
import { GroupCreate } from './GroupCreate'

import { AdminLogList } from './AdminLogList'

import * as urls from './urls'

export const AdminUserResourceName = 'Admin User';

export const AdminUserResources = [
  {
    'name': AdminUserResourceName,
    'frontendPath': urls.adminUserFrontendPath,
    'backendPath': urls.adminUserBackendPath,
    'list': AdminUserList,
    'create': AdminUserCreate,
    'edit': AdminUserEdit,
    'showInSideMenu': true,
  },
  {
    'name': 'Admin Group',
    'frontendPath': urls.groupFrontendPath,
    'backendPath': urls.groupBackendPath,
    'list': GroupList,
    'edit': GroupEdit,
    'create': GroupCreate,
    'showInSideMenu': true,
  },
  {
    'name': 'Admin Log',
    'frontendPath': urls.adminLogFrontendPath,
    'backendPath': urls.adminLogBackendPath,
    'list': AdminLogList,
    'showInSideMenu': true,
  },

];

export const AdminUserCustomRoutes = [];


// WEBPACK FOOTER //
// ./src/routes/user/resources.js